// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__227MV","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1EOst"};